import { useEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import commonUtil from "../../common/commonUtil";
import { getFacilityInfo } from "../../const";
import { food } from "../../reducers/membership_hotel/food";
import common from "../../resources/js/common/common";
import { Label } from "../atoms/label";
import { OptionPullDown } from "../atoms/optionPullDown";
import './../../resources_membership_hotel/css/hotel/reserve.css';
import { ModalOptionForm } from "./modalOptionForm";
import { PullDownOptionForm } from "./pullDownOptionForm";

const ConditionDesignationArea = (props) => {
    const {
        state,
        checkIn,
        checkOut,
        room,
        adultNum,
        childNum,
        setRoom,
        setAdultNum,
        setChildNum,
        resvKaiinken,
        setResvKaiinken,
        planConditions,
        food,
        privilegedService,
        setPlanConditions,
        setFood,
        setPrivilegedService,
        membershipFacility,
        setMembershipFacility,
        style,
        conditionChanged,
        setConditionChanged,
        getPopUpCheckedInfo,
        isMobilePhone,
        onClickOpenCalendarWindow,
        onClickOpenCheckListWindow,
        errFlgList,
        setDispFacility,
        setDispDetailCondition,
        setOpenFacilityFlg,
        kaiinkenNumber,
        setKaiinkenNumber,
        roomNumber,
        setRoomNumber,
        dispAdultNum,
        setDispAdultNum,
        dispChildNum,
        setDispChildNum,
        setSelectKeiyakuNo
    } = props;

    const store = useStore();

    useEffect(() => {
        if (conditionChanged || (state.popupMode == "savedSearch" && !state.reservationPopup)) {
            displaySearchConditions();
            setConditionChanged(false)
        }
    }, [state.reservationPopup, conditionChanged]);


    // 検索条件初期表示
    const displaySearchConditions = () => {
        resvKaiinken.forEach((data) => {
            if (data.selected === true) setKaiinkenNumber(data.id);
        });
        room.forEach((data) => {
            if (data.selected === true) setRoomNumber(data.id);
        });
        adultNum.forEach((data) => {
            if (data.selected === true) setDispAdultNum(data.id);
        });
        childNum.forEach((data) => {
            if (data.selected === true) setDispChildNum(data.id);
        });
    }

    // チェックイン表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkInDate = new Date(checkIn);
        const y = checkInDate.getFullYear();
        const m = checkInDate.getMonth() + 1;
        const d = checkInDate.getDate();

        return `${y}年${m}月${d}日(${youbi[checkInDate.getDay()]})`;
    }
    // チェックアウト表示処理
    const getDateToString2 = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkOutDate = new Date(checkOut);
        const y = checkOutDate.getFullYear();
        const m = checkOutDate.getMonth() + 1;
        const d = checkOutDate.getDate();

        return `${y}年${m}月${d}日(${youbi[checkOutDate.getDay()]})`;
    }

    // 施設表示
    const getFacility = () => {
        let dispText = store.getState().dispFacility ? store.getState().dispFacility : "選択なし";
        return dispText;
    }

    // 詳細条件表示
    const getDetailCriteria = () => {
        let dispText = store.getState().dispDetailCondition ? store.getState().dispDetailCondition : "選択なし";
        return dispText;
    }

    const onChangeKaiinkenName = (e) => {
        let keiyakuNo = "";
        let selectShisetsuCd = "";
        const kaiinkenRef = e.target.value;
        resvKaiinken.forEach((data) => {
            if (String(data.id) === kaiinkenRef) {
                data.selected = true;
                keiyakuNo = data.keiyakuNo;
                selectShisetsuCd = data.sisetuCd;
            } else {
                data.selected = false;
            }
        })
        membershipFacility.membership.forEach(group => {
            const selectedFacility = group.shisetsuList.find(facility => facility.id == selectShisetsuCd);
            if (selectedFacility) {
                setOpenFacilityFlg(selectedFacility.openFlg);
            }
        });
        setSelectKeiyakuNo(keiyakuNo);
        setResvKaiinken(resvKaiinken);
        // 施設・部屋グレード情報取得
        common.doPostRef(getFacilityInfo, { keiyakuNo: keiyakuNo }, kaiinkenRef, afterGetFacilityInfo);
    }
    // 施設・部屋グレード情報取得後処理
    const afterGetFacilityInfo = (res, kaiinkenRef) => {
        const data = res.data;
        if (data.resultCode == 0) {
            getPopUpCheckedInfo(data);
            setKaiinkenNumber(kaiinkenRef);
        }
    }

    // 選択した組数をstoreに保存
    const onChangeRoom = (e) => {
        setRoomNumber(e.target.value);

        room.forEach((data) => {
            if (data.id === e.target.value) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setRoom(room);
    };
    // 選択した組数をstoreに保存
    const onChangeAdultNum = (e) => {
        setDispAdultNum(e.target.value);
        const selected = e.target.value;
        adultNum.forEach((data) => {
            if (data.id === selected) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setAdultNum(adultNum);
    };
    // 選択した組数をstoreに保存
    const onChangeChildNum = (e) => {
        setDispChildNum(e.target.value);
        const selected = e.target.value;
        childNum.forEach((data) => {
            if (data.id === selected) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setChildNum(childNum);
    };
    return (
        <>
            <div style={style.container}>
                <ModalOptionForm
                    id={"checkIn"}
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    title={"チェックイン"}
                    onClick={onClickOpenCalendarWindow}
                    text={getDateToString()} />
                <div className={isMobilePhone ? "conditionWrapSP" : "conditionWrap"}   >
                    <ModalOptionForm
                        id={"checkOut"}
                        divClass={"membershipWrap"}
                        title={"チェックアウト"}
                        onClick={onClickOpenCalendarWindow}
                        text={getDateToString2()} />
                    <div className="membership_search_condition_info">
                        ※最大６泊まで予約可能
                    </div>
                </div>
                <ModalOptionForm
                    id={"facility"}
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    title={"ホテル"}
                    onClick={onClickOpenCheckListWindow}
                    text={getFacility()}
                    dateClass={errFlgList.errFacility ? "popupButtonErr" : ""} />
                <div className={isMobilePhone ? "wrapMobile" : "wrap"}>
                    <Label className={"membershipModalLabel"} label={isMobilePhone ? "1室あたり利用人数\n（小学生未満の人数は入力不要）" : "1室あたり利用人数（小学生未満の人数は入力不要）"} />
                    <div className={isMobilePhone ? "" : "humanInput"}>
                        <div className={isMobilePhone ? "humanPullDownSp" : "humanPullDown"}>
                            <Label className={"modalLabel"} label="大人" />
                            <OptionPullDown
                                data={adultNum}
                                selectClass={errFlgList.errPeopleNum || errFlgList.errAdultNum ? "humanPullDownOptionStyleErr" : "humanPullDownOptionStyle"}
                                onChange={onChangeAdultNum}
                                value={dispAdultNum}
                                id="adultNum" />
                        </div>
                        <div className={isMobilePhone ? "humanPullDownSp" : "humanPullDown"}>
                            <Label className={"modalLabel"} label="小学生" />
                            <OptionPullDown
                                data={childNum}
                                selectClass={errFlgList.errPeopleNum ? "humanPullDownOptionStyleErr" : "humanPullDownOptionStyle"}
                                onChange={onChangeChildNum}
                                value={dispChildNum}
                                id="childNum" />
                        </div>
                    </div>
                </div>
                <PullDownOptionForm
                    id="roomNum"
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    title={"室数"}
                    selectClass="pullDownOptionStyle"
                    labelClassName="modalLabel"
                    data={room}
                    state={roomNumber}
                    onChange={onChangeRoom} />
                <PullDownOptionForm
                    id="kaiinken"
                    divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                    title={"会員権選択"}
                    selectClass="pullDownOptionKaiinkenStyle"
                    labelClassName="modalLabel"
                    data={resvKaiinken}
                    state={kaiinkenNumber}
                    onChange={onChangeKaiinkenName} />
                <ModalOptionForm
                    id={"detailCriteria"}
                    divClass={isMobilePhone ? "wrapMobile" : "detailCriteriaWrap"}
                    title={"詳細条件"}
                    onClick={onClickOpenCheckListWindow}
                    text={getDetailCriteria()} />
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        room: state.room,
        detailCondition: state.detailCondition,
        membershipFacility: state.membershipFacility,
        planConditions: state.planConditions,
        food: state.food,
        privilegedService: state.privilegedService,
        resvKaiinken: state.resvKaiinken,
        adultNum: state.adultNum,
        childNum: state.childNum,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setResvKaiinken: (item) => {
            dispatch({ type: "RESV_KAIINKEN", payload: { resvKaiinken: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
        setPlanConditions: (item) => {
            dispatch({ type: "PLAN_CONDITIONS", payload: { planConditions: item } })
        },
        setPrivilegedService: (item) => {
            dispatch({ type: "PRIVILEGED_SERVICE", payload: { privilegedService: item } })
        },
        setFood: (item) => {
            dispatch({ type: "FOOD", payload: { food: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: "DISP_FACILITY", payload: { dispFacility: item } })
        },
        setDispDetailCondition: (item) => {
            dispatch({ type: "DISP_DETAIL_CONDITION", payload: { dispDetailCondition: item } })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConditionDesignationArea);